// constants
import { arrowImage } from 'constants/images';

// libraries
import styled from 'styled-components';

export const StyledCompanySwiper = styled.div`
  overflow: visible;
  overflow-x: clip;

  .swiper-container {
    position: relative;
    width: 415px;
    height: 133px;
    overflow: visible;
  }

  .swiper {
    overflow: visible;

    &-wrapper {
      align-items: center;
    }

    &-slide {
      display: flex;
      border: 1px solid #e4e4e4;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      opacity: 0;
      transform: scale(0.9167);
      background: #f8f8f8;
      border-radius: 4px;
      transition:
        transform 0.3s ease,
        background 0.3s ease;

      &-active {
        z-index: 10;
        height: 132.7px !important;
        background: #fff;
        font-size: 32px;
        transform: scale(1);
        border: 1px solid #e4e4e4;
        box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
        opacity: 1;

        .img-logo {
          height: 24px;
        }
      }

      &-prev,
      &-next {
        height: 96.51px !important;
        opacity: 0.5;
        background: #f8f8f8;
        font-size: 24px;

        .img-logo {
          height: 22px;
        }
      }
    }

    &-button {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: #f8f8f8;
      background-repeat: no-repeat;
      background-position: center;
      top: var(--swiper-navigation-top-offset, calc(50% + 10px));

      &-prev {
        &::after {
          content: '' !important;
        }
        left: 6px;
        background-image: url(${arrowImage.arrowPrev});
      }

      &-next {
        &::after {
          content: '' !important;
        }
        right: 6px;
        background-image: url(${arrowImage.arrowNext});
      }
    }
  }
`;
